export default "__VITE_ASSET__CFJDWZ9L__"